import { useQuery } from '@tanstack/react-query';
import { isApiError } from '@/shared/lib/apiClient';
import {
  PLATFORM_USAGE_QUERY_KEYS,
  PLATFORM_USAGE_RECENT_LIMIT,
  PLATFORM_USAGE_REFETCH_INTERVAL_MS,
} from '../constants';
import { fetchPlatformUsageRecent } from '../services/platformUsage.api';

export function usePlatformUsageRecent(enabled: boolean, limit = PLATFORM_USAGE_RECENT_LIMIT) {
  return useQuery({
    queryKey: PLATFORM_USAGE_QUERY_KEYS.recent(limit),
    queryFn: ({ signal }) => fetchPlatformUsageRecent(limit, signal),
    enabled,
    staleTime: 15_000,
    refetchInterval: enabled ? PLATFORM_USAGE_REFETCH_INTERVAL_MS : false,
    refetchIntervalInBackground: false,
    retry: (failureCount, error) => {
      if (isApiError(error) && (error.status === 401 || error.status === 403)) {
        return false;
      }
      return failureCount < 1;
    },
  });
}
